import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { parseApiError, overrideOrganizationHeader } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { ENTERPRISE_USERS_QUERY_KEY } from 'hooks/queries/enterprise';
import { ORGANIZATION_INVITATIONS_QUERY_KEY } from 'hooks/queries/organization';

type UseDeleteInvitationMutation = UseMutationResult<
  AxiosResponse<unknown>,
  unknown,
  string
>;

export const useDeleteInvitationMutation = (
  orgId?: string
): UseDeleteInvitationMutation => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (invitationId) =>
      apiClient.user.deleteInvitation(
        { id: invitationId },
        orgId ? { headers: overrideOrganizationHeader(orgId) } : undefined
      ),
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
    onSuccess: () => {
      notify.success('Invitation deleted successfully');
      queryClient.invalidateQueries({
        queryKey: [ENTERPRISE_USERS_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [ORGANIZATION_INVITATIONS_QUERY_KEY],
      });
    },
  });
};
